<template>
  <div class="main-layout">
    <!-- 页面头部 -->
    <header class="main-header">
      <CommonHeader />
    </header>

    
    <!-- 主要内容区域 -->
    <main class="main-content" role="main">
      <router-view />
    </main>
    
    <!-- 页面底部 -->
    <footer class="main-footer">
      <CommonFooter />
    </footer>
  </div>
</template>

<script>
import CommonHeader from '../components/common/CommonHeader.vue'
import CommonFooter from '../components/common/CommonFooter.vue'

export default {
  name: 'MainLayout',
  components: {
    CommonHeader,
    CommonFooter
  },
  
  mounted() {
    // 确保页面滚动行为正常
    this.initializeLayout()
    // const platformName = this.$channelMaterial.getMytest('platformName')
    // console.log(platformName);
    
  },
  
  methods: {
    /**
     * 初始化布局设置
     */
    initializeLayout() {
      document.body.style.overflow = 'auto'
      // 添加页面加载完成的标识
      this.$nextTick(() => {
        document.body.classList.add('layout-ready')
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* ===== 主布局容器 ===== */
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
}

/* ===== 页面头部 ===== */
.main-header {
  flex-shrink: 0;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
}

/* ===== 主要内容区域 ===== */
.main-content {
  flex: 1;
  width: 100%;
  min-height: 0;
  box-sizing: border-box;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
}

/* ===== 页面底部 ===== */
.main-footer {
  flex-shrink: 0;
  width: 100%;
  margin-top: auto;
  box-sizing: border-box;
}

@media print {
  .main-layout {
    display: block !important;
    min-height: unset !important;
  }
  .main-header {
    position: static !important;
    z-index: auto !important;
  }
  .main-content {
    overflow: visible !important;
    overflow-y: visible !important;
    overflow-x: visible !important;
    height: auto !important;
    min-height: unset !important;
    padding: 0 !important;
  }
  .main-footer {
    margin-top: 0 !important;
  }
}
</style>
